const selectTheme = {
    control: (provided) => ({
        ...provided,
        width: "290px",
    }),
};

export { selectTheme };
